import { render, staticRenderFns } from "./MomentOfInertiaViz.vue?vue&type=template&id=13d1f29e&scoped=true"
import script from "./MomentOfInertiaViz.vue?vue&type=script&lang=js"
export * from "./MomentOfInertiaViz.vue?vue&type=script&lang=js"
import style0 from "./MomentOfInertiaViz.vue?vue&type=style&index=0&id=13d1f29e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1f29e",
  null
  
)

export default component.exports